export default "__VITE_ASSET__CbjpbXPJ__"